<template>
  <div class="bike_list_classic_descr mr-0">
    <div class="bike_list_cont">
      <div class="bike-title">{{ infobike.nome }}</div>
      <div class="bike-descr">
        <div class="bike_container">
          <div class="img_bike_classic">
            <img src="../../../images/project-img/ico-classic-grey.png" alt="auto icon" width="140px" />
          </div>
          <div class="row_descr row_descr_2">
            <div>
              <div class="single_row">
                <span class="label-bold">Cilindrata:</span>
                <span class="text-bold">{{ infobike.cilindrata }} cc</span>
              </div>
              <div class="single_row">
                <span>In commercio dal</span>
                <span class="text-bold">{{ infobike.annoInizio || infobike.inizioVendita }}</span>
                <span>al</span>
                <span class="text-bold">{{ infobike.annoFine || infobike.fineVendita }}</span>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassicBikeContainer',
  props: {
    infobike: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ClassicBikeContainer.vue